import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatureFlagDisabledDirective } from './directives/feature-flag-disabled.directive';
import { FeatureFlagEnabledDirective } from './directives/feature-flag-enabled.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [FeatureFlagEnabledDirective, FeatureFlagDisabledDirective],
  exports: [FeatureFlagEnabledDirective, FeatureFlagDisabledDirective],
  providers: [],
})
export class FeatureFlagsModule {}
